import React, { useCallback, useEffect, useState } from "react";
import { handleRequestError } from "../../../../../../utils/formValidationUtils";
import {
  processCreateRequestStatus,
  processUpdateRequestStatus,
} from "../../../../../../utils/dataComponentUtils";
import CreateTemplateCategoryForm from "./CreateTemplateCategoryForm";
import propTypes from "../../../../../../constants/propTypes";
import { getDataComponent } from "../../../../../../reducers/dataComponentReducer";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import { closeModalDialog } from "../../../../../../actions/layoutActions";
import {
  performCreateRequest,
  performUpdateRequest,
  setReload,
} from "../../../../../../actions/dataComponentActions";
import useUserRole from "../../../../../../components/hooks/useUserRole";
import useAuthUser from "../../../../../../components/hooks/useAuthUser";
import { isSuperAdmin } from "../../../../../../utils/roleUtils";

export const dataComponentId = "TemplateCategoriesGrid";

export const processRequestResponse = ({
  prevDataComponent,
  dataComponent,
  closeModalDialog,
  setReload,
  formikActions,
}) => {
  processCreateRequestStatus(prevDataComponent, dataComponent, {
    onSuccess: () => {
      closeModalDialog();
      setReload(dataComponentId, true);
    },
    onError: error => handleRequestError(error, formikActions),
  });

  processUpdateRequestStatus(prevDataComponent, dataComponent, {
    onSuccess: () => {
      closeModalDialog();
      setReload(dataComponentId, true);
    },
    onError: error => handleRequestError(error, formikActions),
  });
};

const CreateTemplateCategoryContainer = ({
  dataComponent,
  closeModalDialog,
  setReload,
  instance: { id: sourceId, ...instance },
  performCreateRequest,
  performUpdateRequest,
}) => {
  const [prevDataComponent, setPrevDataComponent] = useState(dataComponent);
  const [formikActions, setFormikAction] = useState(null);

  useEffect(() => {
    setPrevDataComponent(dataComponent);
  }, [dataComponent]);

  useEffect(() => {
    processRequestResponse({
      prevDataComponent,
      dataComponent,
      closeModalDialog,
      setReload,
      formikActions,
    });
  });

  const handleSubmit = useCallback(
    (newEntity, formikActions) => {
      setFormikAction(formikActions);
      if (sourceId) {
        return performUpdateRequest(dataComponentId, sourceId, newEntity);
      }

      performCreateRequest(dataComponentId, newEntity);
    },
    [performCreateRequest, sourceId, performUpdateRequest]
  );

  const userRole = useUserRole();
  const { office } = useAuthUser();
  const isCreatingSuperAdmin = isSuperAdmin(userRole) && !sourceId;

  return (
    <CreateTemplateCategoryForm
      initialValues={{
        ...instance,
        ...(isCreatingSuperAdmin && !instance.scopeId
          ? { scopeId: office?.scopeId }
          : {}),
      }}
      onSubmit={handleSubmit}
      isEditing={!!sourceId}
      isSuperAdmin={isSuperAdmin(userRole)}
      dataComponentId={dataComponentId}
    />
  );
};

CreateTemplateCategoryContainer.defaultProps = {
  instance: {
    name: undefined,
  },
};

CreateTemplateCategoryContainer.propTypes = {
  dataComponent: propTypes.dataComponent,
  instance: propTypes.templateCategory,
  closeModalDialog: PropTypes.func.isRequired,
  performCreateRequest: PropTypes.func.isRequired,
  performUpdateRequest: PropTypes.func.isRequired,
  setReload: PropTypes.func.isRequired,
};

export const mapDispatchToProps = {
  closeModalDialog,
  performCreateRequest,
  performUpdateRequest,
  setReload,
};

const mapStateToProps = state => {
  const dataComponent = getDataComponent(dataComponentId, state);
  return {
    dataComponent,
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(CreateTemplateCategoryContainer);
